import React from 'react';
import Card from '../../components/ui/Card.jsx';
import Input from '../../components/ui/Input.jsx';
import Button from '../../components/ui/Button.jsx';
import { apiFetch } from '../../api.js';
import { useApi } from '../../hooks/useApi.js';

export default function StudentProfile() {
  const { data, loading, error } = useApi('/api/students/me');
  const [form, setForm] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [message, setMessage] = React.useState({ text: '', tone: 'info' });

  React.useEffect(() => {
    if (!data) return;
    setForm({
      personalEmail: data.personal_email || ''
    });
  }, [data]);

  const updateField = (key) => (event) => {
    setForm((prev) => ({ ...prev, [key]: event.target.value }));
  };

  const handleReset = () => {
    if (!data) return;
    setForm({
      personalEmail: data.personal_email || ''
    });
    setMessage({ text: '', tone: 'info' });
  };

  const handleSave = async () => {
    if (!form) return;
    setSaving(true);
    setMessage({ text: '', tone: 'info' });
    try {
      await apiFetch('/api/students/me', {
        method: 'PUT',
        body: JSON.stringify({
          personal_email: form.personalEmail
        })
      });
      setMessage({ text: 'Profile updated.', tone: 'info' });
    } catch (err) {
      setMessage({ text: err?.message || 'Failed to update profile.', tone: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Profile</h1>
          <p className="subtle">Keep your contact information current.</p>
        </div>
      </div>
      {error ? <div className="alert error">{error}</div> : null}
      {message.text ? <div className={message.tone === 'error' ? 'alert error' : 'alert'}>{message.text}</div> : null}
      {loading || !form ? (
        <p className="subtle">Loading...</p>
      ) : (
        <Card title="Student Details">
          <div className="summary-list">
            <div className="summary-row">
              <span>First Name</span>
              <span>{data.first_name || '—'}</span>
            </div>
            <div className="summary-row">
              <span>Last Name</span>
              <span>{data.last_name || '—'}</span>
            </div>
            <div className="summary-row">
              <span>CIN</span>
              <span>{data.cin || '—'}</span>
            </div>
            <div className="summary-row">
              <span>Cal State LA Email</span>
              <span>{data.username || '—'}</span>
            </div>
          </div>
          <div className="form-grid">
            <Input label="Personal Email" value={form.personalEmail} onChange={updateField('personalEmail')} />
          </div>
          <div className="form-actions">
            <Button variant="secondary" type="button" onClick={handleReset}>Reset</Button>
            <Button type="button" disabled={saving} onClick={handleSave}>{saving ? 'Saving…' : 'Save Changes'}</Button>
          </div>
        </Card>
      )}
    </div>
  );
}
